import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../shared/constants/contactInfo';

function DataDeletionStatus() {
  const [searchParams] = useSearchParams();
  const confirmationCode = searchParams.get('code');

  return (
    <div className="min-h-screen bg-warm-dark font-sans selection:bg-slate-blue/30 selection:text-cream">
      {/* Header */}
      <header className="bg-black/20 backdrop-blur-lg border-b border-white/5 py-6 sticky top-0 z-50">
        <div className="container mx-auto px-6">
          <Link to="/" className="text-2xl font-black tracking-tight text-white hover:text-slate-blue transition-colors flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-slate-blue to-warm-gray flex items-center justify-center text-[10px] text-white/90">NI</span>
            NextAInsight
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-16 max-w-4xl">
        <div className="bg-warm-gray/10 backdrop-blur-xl rounded-[2.5rem] shadow-2xl border border-white/5 p-8 md:p-16 relative overflow-hidden">
          {/* Decorative gradients */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-slate-blue/10 rounded-full blur-[100px] pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-soft-coral/5 rounded-full blur-[80px] pointer-events-none"></div>

          <div className="relative z-10">
            <h1 className="text-4xl md:text-5xl font-black text-cream mb-4 tracking-tight">Data Deletion Status</h1>
            <p className="text-sm font-bold text-slate-blue uppercase tracking-widest mb-12 border-b border-white/10 pb-6 inline-block">Meta Data Deletion Request</p>

            <div className="space-y-10 text-cream/80 leading-relaxed text-lg">
              {confirmationCode ? (
                <>
                  <section>
                    <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2"><span className="w-2 h-8 bg-slate-blue rounded-full"></span> Request Processed</h2>
                    <p>
                      Your data deletion request has been processed. All Meta connection data
                      (access tokens, page connections, and associated account information)
                      has been removed from our systems.
                    </p>
                  </section>

                  <section>
                    <div className="p-4 bg-white/5 rounded-xl border border-white/5">
                      <p className="text-white font-bold mb-2">Confirmation Code</p>
                      <p className="font-mono text-slate-blue text-sm break-all">{confirmationCode}</p>
                    </div>
                  </section>

                  <section>
                    <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2"><span className="w-2 h-8 bg-slate-blue rounded-full"></span> What Was Deleted</h2>
                    <ul className="list-none mt-4 space-y-3 ml-2">
                      <li className="flex items-start gap-2"><span className="text-slate-blue mt-1">✓</span> Encrypted Meta OAuth access tokens</li>
                      <li className="flex items-start gap-2"><span className="text-slate-blue mt-1">✓</span> Facebook Page connection data</li>
                      <li className="flex items-start gap-2"><span className="text-slate-blue mt-1">✓</span> Instagram account connection data</li>
                    </ul>
                  </section>
                </>
              ) : (
                <section>
                  <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2"><span className="w-2 h-8 bg-slate-blue rounded-full"></span> No Confirmation Code</h2>
                  <p>
                    No confirmation code was provided. If you submitted a data deletion request
                    through Facebook, please check the confirmation link you received.
                  </p>
                </section>
              )}

              <section>
                <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2"><span className="w-2 h-8 bg-slate-blue rounded-full"></span> Questions?</h2>
                <p>
                  If you have questions about this deletion or need further assistance, contact us at{' '}
                  <a href={`mailto:${SUPPORT_EMAIL}`} className="text-slate-blue font-bold hover:text-white transition-colors hover:underline">{SUPPORT_EMAIL}</a>.
                </p>
                <p className="mt-3">
                  For details about how we handle your data, see our{' '}
                  <Link to="/privacy-policy" className="text-slate-blue font-bold hover:text-white transition-colors hover:underline">Privacy Policy</Link>.
                </p>
              </section>
            </div>

            {/* Back Link */}
            <div className="mt-16 pt-8 border-t border-white/10">
              <Link
                to="/"
                className="inline-flex items-center text-slate-blue hover:text-white font-bold tracking-wide uppercase text-sm transition-all hover:translate-x-1"
              >
                &larr; Back to Home
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default DataDeletionStatus;
